module.exports = __webpack_public_path__ + "static/media/S (145).d0270e45.jpg";